module.exports = __webpack_public_path__ + "img/hanggar.856ae602.png";